import { FormattedMessage } from "react-intl"
import { ValueDisplay, ValueDisplayWithLabel } from "../../../automationObjects/components/ValueDisplay"
import { timespanToString } from "../../../utils/timeUtils"
import { Block } from "baseui/block"
import { useStyletron } from "baseui"
import { TbRectangleVerticalFilled } from "react-icons/tb"
import { ListItem, ListItemLabel } from "baseui/list"

const TimeSeriesStatisticsItem = (props: { color: string, percentage: number, count: number, duration: any, label: string }) => {
    const [, theme] = useStyletron()

    return (

        <ListItem artwork={() => <TbRectangleVerticalFilled color={props.color} />}>
            <ListItemLabel description={
                <Block display={'flex'} marginTop={'2px'} flexWrap gridColumnGap={theme.sizing.scale600} alignItems={'baseline'}>
                    <ValueDisplay mini value={props.percentage} dimension={'%'}></ValueDisplay>
                    <ValueDisplayWithLabel mini label={<FormattedMessage id='frequency' defaultMessage={'Frequency'}></FormattedMessage>} value={props.count} dimension="x"></ValueDisplayWithLabel>
                    <ValueDisplayWithLabel mini label={<FormattedMessage id='duration' defaultMessage={'Duration'}></FormattedMessage>} value={timespanToString(props.duration)}></ValueDisplayWithLabel>
                </Block>
            }>
                {props.label}
            </ListItemLabel>
        </ListItem>
    )
}

export default TimeSeriesStatisticsItem;

